import React, { useState, useEffect } from 'react';
import "../assets/styles/home.css"

const FilterButton = ({ onClick, testId }) => {
  return (
    <div className="col filter_btn">
      <button onClick={onClick} data-testid={testId}>
        Search
      </button>
    </div>
  );
};

export default FilterButton;